import React from 'react';
import { connect } from 'react-redux';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { refreshActiveReminderCount } from '../../thunks/work_order_user_stars_thunks';
import { ACTIVE_REMINDER_COUNT_COLLECTION } from '../../constants/WorkOrderReminderCollections';

export interface ActiveReminderCountProps {
	// How many of the user's reminders are due (see refreshActiveReminderCount).
	activeReminderCount: number;
	refreshCount: () => void;
}

const mapStateToProps = (state) => ({
	activeReminderCount: nullSafeGetOrElse(
		'pagination.total',
		state.work_orders[ACTIVE_REMINDER_COUNT_COLLECTION],
		0
	),
	userType: state.session.userType,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	...ownProps,
	activeReminderCount: stateProps.activeReminderCount,
	refreshCount: () => dispatchProps.dispatch(refreshActiveReminderCount(stateProps.userType)),
});

// Wires a component to the shared due-reminder count, in the user's role.
const connectActiveReminderCount = <OwnProps = {}>(
	component: React.ComponentType<OwnProps & ActiveReminderCountProps>
): React.ComponentType<OwnProps> =>
	connect(mapStateToProps, (dispatch) => ({ dispatch }), mergeProps)(component as any) as any;

export default connectActiveReminderCount;
